import api, { xiangxinApi } from '@common/api';
import { request } from 'xiangxin-tool';

export const getInvoiceList = (data) => {
  return api.get('/convoy/ds/invoice', {
    params: {
      ...data,
    },
  });
};

export const getInvoiceInfo = (id) => {
  return api.get(`/convoy/ds/invoice/invoice_info/${id}`);
};

export const getInvoiceInfoOrderList = (data, id) => {
  return api.get(`/convoy/ds/invoice/invoice_order_info/${id}`, {
    params: {
      ...data,
    },
  });
};

export const getInvoiceInfoOrderListFy = (data, id) => {
  return api.get(`/convoy/ds/invoice/invoice_item_info/${id}`, {
    params: {
      ...data,
    },
  });
};

export const cancleInvoice = (ids) => {
  return api.put('/convoy/ds/invoice/cancel', { ids: ids });
};

export const getYardInfoList = (data) => {
  return api.get('/resource/yard', {
    params: {
      ...data,
    },
  });
};

export const getShipList = (data) => {
  return api.get('/resource/ship/agent', {
    params: {
      ...data,
    },
  });
};

export const getExpenseList = (data) => {
  return api.get('/convoy/ds/invoice/order_check', {
    params: {
      ...data,
    },
  });
};

export const getExpenseListMoneyInfo = ({
  orderId,
  invoiceType,
  confirmStatus,
  fee_create_time,
  fee_data_id,
  jian_zhang_status,
  apply_invoice_status,
}) => {
  return api.get('/convoy/ds/invoice/order_item_info', {
    params: {
      order_id: orderId,
      invoice_type: invoiceType,
      confirm_status: confirmStatus,
      fee_create_time,
      fee_data_id,
      jian_zhang_status,
      apply_invoice_status,
    },
  });
};

export const getExpenseBase = () => {
  return api.get('/convoy/ds/invoice/info');
};

export const editExpenseBase = (data) => {
  return api.put('/convoy/ds/invoice/info', { ...data });
};

export const getExpenseItemBase = () => {
  return api.get('/convoy/ds/invoice/item_base');
};

export const applyJoinInvoice = ({ invoiceType, orderInfo }) => {
  return request({
    url: '/convoy/ds/invoice/itemJoinInvoice',
    method: 'POST',
    data: {
      invoice_type: invoiceType,
      order_info: orderInfo,
    },
  });
};

export const expenseConfirm = ({ orderInfo }) => {
  return request({
    url: '/convoy/ds/invoice/itemConfirm',
    method: 'POST',
    data: {
      order_info: orderInfo,
    },
  });
};

export const getInvoiceInvoiceInfo = (id) => {
  return api.get(`/convoy/ds/invoice/invoice_info/${id}`);
};
export const getInvoiceInfos = (id) => {
  return api.get(`/convoy/ds/invoice/invoice_info/${id}`);
};

export const getInvoiceOrderList = (id, data) => {
  return api.get(`/convoy/ds/invoice/invoice_order_info/${id}`, {
    params: {
      ...data,
    },
  });
};

export const getInvoiceOrderInfoList = (id, data) => {
  return api.get(`/convoy/ds/invoice/invoice_item_info/${id}`, {
    params: {
      ...data,
    },
  });
};

export const getInvoiceFeeDownload = (id_str) =>
  request({
    url: '/convoy/ds/invoice/download_fee',
    params: {
      id_str,
    },
  });

export const getInvoiceApplyInfo = (id_str) =>
  request({
    url: '/convoy/ds/invoice/apply_info',
    params: {
      id_str,
    },
  });

export const invoiceConfig = () =>
  request({
    url: '/financial/bill/invoice/item_config',
  });

// 发票类别-税点映射（税点集合按票型不同，供票点筛选等场景动态取选项）
export const getInvoiceTaxMap = () =>
  request({
    url: '/financial/unit/invoice_tax_map',
  });

export const invoiceTitleByUnitId = (unit_id) =>
  request({
    url: '/enter/invoicetitle/titles',
    params: {
      unit_id,
    },
  });

export const applyInvoice = (data) =>
  request({
    url: '/financial/bill/invoice',
    method: 'POST',
    data,
  });
